import React, {useEffect, useState} from 'react'
import * as auth from '../redux/actions'
import {useDispatch, useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import axios from 'axios'
import {toast} from 'react-toastify'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL
const FALLBACK_MESSAGE = 'If this email is registered, a password reset link has been sent to it.'

export function EmailSuccess(props: any) {
  const dispatch = useDispatch()
  const {loading, success} = useSelector((state: any) => state.auth)
  const locationState = props.location.state ?? {}
  const email = typeof locationState === 'string' ? locationState : locationState.email
  const message = locationState.message || FALLBACK_MESSAGE
  const [resent, setResent] = useState(false)
  const [googleReCaptchaKey, setGoogleReCaptchaKey] = useState('')

  useEffect(() => {
    axios.get(API_URL + '/frontend/key-setting?name=Recaptcha_Client_V3').then((res) => {
      setGoogleReCaptchaKey(res.data.data.key)
    })
  }, [])

  useEffect(() => {
    if (!googleReCaptchaKey) return
    const script = document.createElement('script')
    script.src = `https://www.google.com/recaptcha/api.js?render=${googleReCaptchaKey}`
    script.async = true
    document.body.appendChild(script)
    return () => {
      document.body.removeChild(script)
    }
  }, [googleReCaptchaKey])

  useEffect(() => {
    if (success) {
      setResent(true)
    }
  }, [success])

  const executeCaptcha = (): Promise<string> =>
    new Promise((resolve, reject) => {
      ;(window as any).grecaptcha.ready(async () => {
        try {
          const token = await (window as any).grecaptcha.execute(googleReCaptchaKey, {
            action: 'forgot_password_resend',
          })
          resolve(token)
        } catch (err) {
          reject(err)
        }
      })
    })

  const handleResend = async () => {
    setResent(false)
    try {
      const captchaToken = await executeCaptcha()
      dispatch(auth.actions.forgotPassword(email, captchaToken))
    } catch (err) {
      toast.error('CAPTCHA verification failed. Please try again.')
    }
  }

  return (
    <div className=''>
      <h4 className='login-box-msg text-center mt-10 mb-5' data-cy='email-success-box-msg'>
        Check your email
      </h4>
      <h5 className='text-center' style={{color: '#4242428d'}}>
        {message}
      </h5>
      <div className='text-center mt-5'>
        <Link to='/auth/login' className='btn btn-lg w-100 mb-5' data-cy='email-success-submit-button'>
          Login
        </Link>
      </div>
      <div className='text-center mb-5' data-cy='text-email-success-center'>
        {resent && (
          <div className='text-success fs-6 mb-2' data-cy='resend-success-msg'>
            Email resent. Please check your inbox.
          </div>
        )}
        Didn&apos;t receive an email?{' '}
        <span
          className='link-danger fs-6 fw-bolder cursor-pointer'
          data-cy='link-email-success'
          onClick={handleResend}
        >
          {loading ? 'Sending...' : resent ? 'Resend again' : 'Resend'}
        </span>
      </div>
    </div>
  )
}
